module.exports = __webpack_public_path__ + "img/organize.5a3a1f20.png";